import { inject, Injectable } from '@angular/core';
import { ConfigFacade } from '../state/config.facade';
import { LocalStorageService } from 'ngx-webstorage';

@Injectable({
  providedIn: 'root',
})
export class CidStorageService {
  #localStorageKey = 'cidStorageObject';
  #localStorageService = inject(LocalStorageService);
  #configFacade = inject(ConfigFacade);

  getOrGenerateCID(): string {
    const storedCid = this.#getCID();
    if (storedCid) {
      return storedCid;
    }
    const newCid = this.#generateCID();
    this.#saveCID(newCid);
    return newCid;
  }

  clearCID(): void {
    this.#localStorageService.clear(this.#localStorageKey);
  }

  #saveCID(cid: string): void {
    this.#localStorageService.store(this.#localStorageKey, cid);
  }

  #generateCID(): string {
    const guid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      /* eslint-disable no-bitwise */
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });

    this.#configFacade.generateCidSucceed(guid);

    return guid;
  }

  #getCID(): string | null {
    const cid = this.#localStorageService.retrieve(this.#localStorageKey);
    if (cid) {
      this.#configFacade.readCidSucceed(cid);
    }
    return cid;
  }
}
